import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IAgent, IAgentDetails, IAgentState } from "./agentModel";
import {
  ActiveInactiveAgent,
  agentdocumentupload,
  createAgent,
  deleteAgent,
  getAgentByID,
  getAllActiveAgent,
  getAllAgent,
  // updateAgent,
} from "./services/agent.service";

const initialState: IAgentState = {
  loading: false,
  error: "",
  AgentID: null,
  AgentList: [],
  AgentDetail: {
    SubAgentName: "",
    CompanyName: "",
    Password: "",
    CompanyAddress: "",
    PinCode: "",
    CountryID: null,
    StateID: null,
    CityID: null,
    ContactNo: "",
    EmailID: "",
    GSTNo: "",
    PanNo: "",
    AadharNo: "",
    UniversalMarkupTypeID: null,
    UniversalMarkup: "",
    AadharDocument: "",
    PanDocument: "",
    GSTDocument: "",
    OperationType: null,
    Logo: "",
    IsActive: 1,
    ContactDetails: [],
    BankDetails: [],
  },
  deleteIndex: -1,
};

const agentSlice = createSlice({
  name: "agent",
  initialState,
  reducers: {
    clearAgentDetails: (state) => {
      state.AgentDetail = initialState.AgentDetail;
    },
    setAgentID: (state, action) => {
      state.AgentID = action.payload;
    },
    clearAgentID: (state) => {
      state.AgentID = initialState.AgentID;
    },
    setAgentContactDeleteIndex: (state, action) => {
      state.deleteIndex = action.payload;
    },
    setBankDeleteIndex: (state, action) => {
      state.deleteIndex = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getAllAgent.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(
      getAllAgent.fulfilled,
      (state, action: PayloadAction<IAgent[]>) => {
        state.loading = false;
        state.AgentList = action.payload || [];
      }
    );
    builder.addCase(getAllAgent.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
      state.AgentList = [];
    });
    builder.addCase(getAllActiveAgent.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(
      getAllActiveAgent.fulfilled,
      (state, action: PayloadAction<IAgent[]>) => {
        state.loading = false;
        state.AgentList = action.payload || [];
      }
    );
    builder.addCase(getAllActiveAgent.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
      state.AgentList = [];
    });
    builder.addCase(createAgent.pending, (state) => {
      state.loading = false;
      state.error = "";
    });
    builder.addCase(createAgent.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(createAgent.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });

    builder.addCase(deleteAgent.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(deleteAgent.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(deleteAgent.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(getAgentByID.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(
      getAgentByID.fulfilled,
      (state, action: PayloadAction<IAgentDetails>) => {
        state.loading = false;
        state.AgentDetail = action.payload;
      }
    );
    builder.addCase(getAgentByID.rejected, (state, action) => {
      state.loading = false;
      state.AgentDetail = initialState.AgentDetail;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(ActiveInactiveAgent.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(ActiveInactiveAgent.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(ActiveInactiveAgent.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });

    builder.addCase(agentdocumentupload.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(agentdocumentupload.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(agentdocumentupload.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });
  },
});

export const {
  clearAgentDetails,
  setAgentID,
  clearAgentID,
  setAgentContactDeleteIndex,
  setBankDeleteIndex,
} = agentSlice.actions;
export default agentSlice.reducer;
